/**
 * KODLAMA ÇÖZÜCÜLERİ — `email-mask.ts`in 2. NORMALLEŞTİRME ADIMI.
 *
 * AYRI DOSYA, ÇÜNKÜ ÇÖZÜCÜ LİSTESİ BÜYÜR: maskeleme kuralı (desen + çıktı
 * kararı) sabit kalırken çözücüler her yeni kodlama biçiminde bir satır daha
 * alır. Ayrım kavramsaldır, mekanik değil: BURASI "metin hangi biçimlerde
 * yazılmış olabilir" sorusunu cevaplar, `email-mask.ts` "adres nasıl görünür
 * ve ne döneriz" sorusunu, `email-mask-binary.ts` "hangi TABANDA yazılmış"ı.
 *
 * Dosya `domain/index.ts`ten DIŞARI AÇILMAZ: tek tüketicisi `email-mask.ts`tir
 * ve kamuya açık yüzey `maskEmails` olarak kalır.
 */
import { b64Bayt, ikiliGovdeleriCoz, utf16beMetin, utf8Metin } from './email-mask-binary';
export { IKILI_GOVDELER, ikiliGovdeleriCoz } from './email-mask-binary';
/* --- 2. KODLAMALARI ÇÖZ (SABİT NOKTAYA KADAR) -----------------------------
 *
 * ÇİFT KODLAMA BU ADIMIN VARLIK SEBEBİDİR: `%2540` tek turda `%40` olur,
 * ikinci turda `@`. Tek geçişli bir çözücü ilkini görür, ikincisini kaçırır —
 * QA'nın `…?to=ali%2540ornek.com` vakası tam buydu.
 *
 * SONLANMA: aşağıdaki çözücülerin HEPSİ metni KISALTIR (en az iki karakter →
 * bir karakter), bu yüzden sabit nokta en çok `metin.length` turda gelir ve
 * döngü kendiliğinden durur. Tavan buna rağmen vardır: ileride metni UZATAN
 * bir çözücü eklenirse (ör. varlık genişletmesi) döngü sonsuza gitmemelidir.
 */
export const KOD_COZUM_TAVANI = 12;
/* --- 2e. HTML ADLI VARLIK — LİSTE DEĞİL, ROL ------------------------------
 *
 * YEDİNCİ DALGA (QA, 16.09.2026): tablo ON BİR üyelikti ve ON DÖRT adlı varlık
 * sızdı — `&shy; &zwnj; &zwj; &ZeroWidthSpace; &lrm; &rlm; &NoBreak; &ensp;
 * &emsp; &thinsp; &hairsp; &zwsp; &Tab; &NewLine;`. Aynı karakterin SAYISAL
 * yazımı (`&#x200B;`) maskeleniyordu: bir yazım kapalı, öbürü açıktı. Tabloya
 * on dört satır eklemek sekizinci dalgayı doğurur — HTML5 adlı varlık kümesi
 * 2231 üyedir ve bir kara liste olarak taşınamaz.
 *
 * KURAL KARAKTERİN ROLÜNE DAYANIR, ADINA DEĞİL. Adlı varlık İKİ sınıftır:
 *
 *  1. YAPISAL — adres kuran GÖRÜNÜR karakteri üretir (`@ . : / # & ' " < > `).
 *     Bu küme desende anlam taşır, sonludur ve büyümez; adları tek tek yazılır.
 *  2. DİĞER HEPSİ — adres KURMAZ. Adres kurmaya tek katkısı BİTİŞİKLİĞİ
 *     BOZMAKTIR, yani rolü görünmez/boşluk sınıfının aynısıdır. Bu yüzden
 *     kanonik görünümde SÖKÜLÜR — tıpkı çözüldükten sonra `\p{Cf}` ve
 *     `\p{Zs}`nin söküldüğü gibi. Liste gerekmez.
 *
 * SÖKMEK FAIL-CLOSED YÖNDÜR: karakter silmek parçaları YAKLAŞTIRIR, yani
 * deseni ancak DAHA ÇOK eşleştirebilir; bir adresi gizlemesi mümkün değildir
 * (adres kuran karakterler yukarıdaki yapısal kümededir). Tanı metnine maliyeti
 * ise SIFIRA YAKINDIR: sökülmüş biçim yalnız EŞLEŞME görünümünde yaşar, çıktıya
 * ancak HAM görünüm adresi bulamadığında ulaşır (bkz. `email-mask.ts` çok
 * görünümlü maskeleme).
 */
const HTML_ADLI = {
    amp: '&',
    apos: "'",
    commat: '@',
    colon: ':',
    gt: '>',
    lt: '<',
    nbsp: '\u00A0',
    num: '#',
    period: '.',
    quot: '"',
    sol: '/',
};
const YUZDE_KODU = /%([0-9A-Fa-f]{2})/g;
const HTML_ONALTILIK = /&#[xX]([0-9A-Fa-f]{1,6});?/g;
const HTML_ONDALIK = /&#(\d{1,7});?/g;
/** Ad uzunluğu HTML5'in en uzun varlık adını (`CounterClockwiseContourIntegral`) kapsar. */
const HTML_AD = /&([A-Za-z][A-Za-z0-9]{1,31});/g;
/*
 * TAŞIMA DOLGUSU DA YUTULUR (QA, dokuzuncu dalga · 17.09.2026). RFC 2045 §6.7
 * `=` ile CRLF arasında BOŞLUK/SEKME dolgusuna açıkça izin verir ("transport
 * padding") ve aktarım katmanı bunu gerçekten ekler. Eski desen yalnız bitişik
 * hâli tanıyordu: `qd910=  \r\nveli@ornek.com` yazımında yerel adın ilk parçası
 * maskenin DIŞINDA kalıyordu.
 */
const QP_YUMUSAK_SATIR = /=[ \t]*\r?\n/g;
const JS_KACISI = /\\u\{([0-9A-Fa-f]{1,6})\}|\\u([0-9A-Fa-f]{4})|\\x([0-9A-Fa-f]{2})/g;
/* --- 2f. CSS KAÇIŞI (`\000040`) — YAPISAL KARAKTER KAPISIYLA ---------------
 *
 * SEKİZİNCİ DALGA (tech-lead, 16.09.2026). Sağlayıcının HTML hata gövdesi
 * `<style>` taşıyabilir ve CSS kaçışı `\` + 1-6 onaltılık basamaktır:
 * `content:"qauser8\000040ornek.com"` panelde yerel ad ve alan adı YAN YANA
 * okunuyordu. `\u0040` (JS) ve `%40` (yüzde) zaten çözülüyordu; aynı karakterin
 * ÜÇÜNCÜ yazımı açıktı — "bir yazım kapalı, öbürü açık" sınıfının aynısı (2e).
 *
 * KAPI `qpTekSekizli` İLE AYNI: yalnız YAPISAL karakter üretiyorsa çözülür.
 * Alfasayısal bir harfi kaçırmanın adres kurmaya faydası yoktur ve gerçek
 * metindeki ters bölü dizileri (`\n`, `\t`, `\b`, Windows yolları) kontrol
 * karakterine ya da harfe indiği için DOKUNULMAZ kalır.
 */
const CSS_KACISI = /\\([0-9A-Fa-f]{1,6})[ \t]?/g;
function yapisalAscii(kod) {
    if (kod <= 0x20 || kod > 0x7e)
        return null;
    const harf = String.fromCharCode(kod);
    return /[0-9A-Za-z]/.test(harf) ? null : harf;
}
function kodNoktasi(onaltilik) {
    const kod = Number.parseInt(onaltilik, 16);
    if (!Number.isFinite(kod) || kod < 0 || kod > 0x10ffff)
        return null;
    return String.fromCodePoint(kod);
}
/**
 * KAYDIRMA DİZİSİ KAPISI (UTF-7 `+AEA-`): orada çözülen gövde adresin TAMAMI
 * değil, yalnız `@`nin kendisidir; yerel adı ve alanı çevredeki metin taşır.
 * Bu yüzden tek bir `@` görmek yeterlidir. (Gömülü İKİLİ gövdelerin kapısı
 * daha sıkıdır ve `email-mask-binary.ts`tedir.)
 */
function atIsareti(metin) {
    return metin.includes('@') || metin.includes('＠');
}
/* --- 2c. AYRAÇ İÇİNE ALINMIŞ GİZLEME (`(at)` / `[dot]`) -------------------
 *
 * Sağlayıcı bunu yazmaz, İNSAN yazar: destek talebinden kopyalanan adres,
 * yeniden gönderim formuna elle girilen alıcı ya da bir aracın "adres
 * gizleme" ayarı. Metin `last_error`a bu biçimde geldiğinde ekranda
 * `ali (at) ornek (dot) com` olarak GÖZLE OKUNUYORDU — yani sızıntı, kodlama
 * kaçamaklarından daha doğrudandı.
 *
 * AYRAÇLI BİÇİM KOŞULSUZ ÇÖZÜLÜR: `(at)`, `[at]`, `{at}`, `<at>` SMTP
 * metninde tesadüfen oluşmaz.
 *
 * ÇIPLAK BİÇİM DE ÇÖZÜLÜR — AMA ÇİFT KOŞULUYLA (QA, beşinci dalga):
 * `at` ile `dot` BİRLİKTE bulunacak. `failed at 12:00` ve
 * `rejected at smtp.gmail.com` bu koşulu sağlamaz, bu yüzden DOKUNULMAZ.
 */
/*
 * AYRAÇ YOKSA İKİ DESEN DE EŞLEŞEMEZ — İSPATLI NO-OP ATLAMASI (tech-lead,
 * sekizinci dalga · 16.09.2026). Bu bir "burada adres olamaz" VARSAYIMI değil:
 * her iki desen de bir ayraç karakterini ZORUNLU kılar, yani ayraçsız metinde
 * eşleşme kümesi boştur. Gerekçe ölçüm: `[ \t]*` öneki uzun boşluk kümesinde
 * her başlangıç noktasından geri izler (karesel) ve 2000 boşlukluk girdide
 * çözüm adımı 4,09 ms sürüyordu; 32 görünüm bunu 143 ms'ye çarpıyordu.
 * Atlamanın çıktıyı DEĞİŞTİRMEDİĞİ korpusun tamamında ölçülür (20. AYAK).
 */
const AYRAC_YOKSA_ATLA = (metin) => !/[([{<]/u.test(metin);
/** Hiçbir metinde eşleşmeyen desen — atlama için yer tutucu. */
const BULUNMAZ = /(?!)/g;
const AYRACLI_AT = /[ \t]*[([{<][ \t]*(?:at|ät)[ \t]*[)\]}>][ \t]*/gi;
const AYRACLI_NOKTA = /[ \t]*[([{<][ \t]*(?:dot|nokta)[ \t]*[)\]}>][ \t]*/gi;
/** Hızlı yolun İSPATI kapıda ölçülür (`email-mask-kesim.spec.ts` 21. AYAK). */
export const AYRACLI_DESENLER = [AYRACLI_AT, AYRACLI_NOKTA];
/*
 * SARMALANMIŞ `@` — SÖZCÜK LİSTESİ DEĞİL, KONUM.
 *
 * `ali(a)ornek.com` ölçüldü ve sızdı: `(a)` `at|ät` listesinde yok. Listeye `a`
 * eklemek sınıfı kapatmaz — `(arobase)`, `(kukac)`, `(chiocciola)` ve `{et}` de
 * aynı şeydir. Kapanan taraf SÖZCÜK değil KONUMDUR: ayraç içinde KISA BİR HARF
 * DİZİSİ, iki yanında BOŞLUK OLMADAN, sağında TLD TAŞIYAN bir alan adı varsa o
 * ayraç bir `@` yazımıdır.
 *
 * YEDİNCİ DALGA EKİ (QA, 16.09.2026): içerik `\p{L}{1,10}` idi ve `@` HARF
 * DEĞİLDİR — yani `(a)` kapatılırken `(@)` açık kalmıştı. Ayrıca `|@|` ve `*@*`
 * bir AYRAÇ ÇİFTİ değil, AYNI karakterin iki yanda tekrarıdır ve köşeli/süslü
 * ayraç listesine girmez. İkisi de aynı yapının yazımı: **`@` işaretinin iki
 * yanına simetrik bir sınırlayıcı konması.** Desen bu yüzden iki almaşık taşır:
 *   1. AYRAÇ ÇİFTİ  — `[([{<]` … `[)\]}>]`, içi kısa harf dizisi YA DA `@`,
 *   2. AYNI KARAKTER — `(X)@\1`, X harf/rakam/boşluk/`@` DIŞINDA tek karakter.
 *
 * Sıkı çapa yanlış pozitifi tutar: `status=deferred (connect timed out)`
 * boşukludur, `errors[0].response` rakam taşır, `(Service: AmazonSimpleEmail…)`
 * harf dışı karakter taşır — üçü de bu desene GİRMEZ (15. AYAK ölçer).
 */
const SARMALANMIS_AT = /(?<=[\p{L}\p{N}])(?:[([{<](?:\p{L}{1,10}|[@＠])[)\]}>]|([^\p{L}\p{N}\s@＠])[@＠]\1)(?=[\p{L}\p{N}][\p{L}\p{N}.-]*\.\p{L}{2,})/giu;
/*
 * ÇOKLU `@` — `kurban@@ornek.com` (QA, yedinci dalga).
 *
 * Desen `YEREL@ALAN` bekler; ikinci `@` ne YEREL'e ne ALAN'a girer, yani ÇİFT
 * yazım maskelemeyi bütünüyle atlatıyordu. Bu bir kodlama değil, bir YAZIM
 * çoğaltmasıdır ve `@`nin kendisi yapısal karakter olduğu için desene
 * `[@＠]+` koymak yerine burada TEKE indirilir: desen sade kalır, HAM görünüm
 * (`email-mask.ts`) `＠` taşıyan metni yanlışlıkla eşleştirmez ve
 * `unicode-nfkc` adımının mutasyon probu yükünü taşımaya devam eder.
 * İki yanı sözcük karakterine ÇAPALIDIR: serbest `@@` dizgesi dokunulmaz kalır.
 */
const COKLU_AT = /(?<=[\p{L}\p{N}])[@＠]{2,}(?=[\p{L}\p{N}])/gu;
/** `ali at ornek dot com` — `at` VE `dot` birlikte; tek başına ` at ` yetmez. */
const SOZCUK_CIFTI = /([\p{L}\p{N}._+-]{1,64})[ \t]+at[ \t]+((?:[\p{L}\p{N}-]+[ \t]+(?:dot|nokta)[ \t]+)+[\p{L}\p{N}-]+)/giu;
/** `ali@ornek dot com` — karma yazım; `@` zaten varsa `dot` tek başına yeter. */
const AT_SONRASI_NOKTA = /(@[\p{L}\p{N}-]+)((?:[ \t]+(?:dot|nokta)[ \t]+[\p{L}\p{N}-]+)+)/giu;
const NOKTA_SOZCUGU = /[ \t]+(?:dot|nokta)[ \t]+/gi;
/** Bitişik encoded-word'ler arasındaki boşluk RFC 2047 §6.2'ye göre YOK SAYILIR. */
const RFC2047_BITISIK = /\?=[ \t]+=\?/g;
const RFC2047 = /=\?[A-Za-z0-9_*.-]{1,40}\?([BbQq])\?([^?\s]{1,600})\?=/g;
const UTF7_KAYDIRMA = /\+([A-Za-z0-9+/,]{2,})-/g;
function rfc2047Coz(tam, kodlama, govde) {
    if (kodlama === 'B' || kodlama === 'b') {
        const baytlar = b64Bayt(govde);
        return (baytlar && utf8Metin(baytlar)) || tam;
    }
    // Q kodlaması: `_` boşluktur, `=HH` sekizlidir (encoded-word İÇİNDE kural nettir).
    const baytlar = [];
    for (let index = 0; index < govde.length; index += 1) {
        const harf = govde[index];
        if (harf === '_') {
            baytlar.push(0x20);
        }
        else if (harf === '=' && /^[0-9A-Fa-f]{2}$/.test(govde.slice(index + 1, index + 3))) {
            baytlar.push(Number.parseInt(govde.slice(index + 1, index + 3), 16));
            index += 2;
        }
        else {
            baytlar.push(harf.charCodeAt(0) & 0xff);
        }
    }
    return utf8Metin(baytlar) ?? tam;
}
/* --- 2b. QUOTED-PRINTABLE: TEK SEKİZLİ YALNIZ YAPISAL KARAKTER ÇÖZER -------
 *
 * ESKİ HÂLİ TANI YÜZEYİNİ BOZUYORDU (tech-lead, 16.09.2026 — ölçüldü):
 *   · `status=deferred` → `statusÞferred`  (`=de` sekizli sanıldı)
 *   · `retry_after=900` → `retry_after<U+0090>0` (GÖRÜNMEZ C1 karakteri kolona
 *     yazılıyordu; ekranda sayı kayboluyordu)
 *   · `reason=4Cxyz`    → `reasonLxyz`
 * Üçü de Postfix/sağlayıcı metinlerinin GÜNLÜK biçimidir ve bozulma yalnız
 * metinde adres VARKEN görünür — yani tam da personelin okumak istediği satırda.
 *
 * AYRIM: `=HH` yazımı iki farklı şeyi anlatır. Kaçış AMAÇLI kullanıldığında
 * hedef `@`, `.`, `%`, `=` gibi YAPISAL karakterlerdir (alfasayısal bir harfi
 * gizlemenin adres kurmaya faydası yoktur — harf zaten desende serbesttir).
 * Gerçek bir QP dizisi ise ARDIŞIKTIR (`=C3=A7`, `=61=6C=69`). Bu yüzden:
 *   · ARDIŞIK zincir → tamamı çözülür (UTF-8 birleştirilerek),
 *   · TEK sekizli → yalnız ASCII yapısal karakter üretiyorsa çözülür.
 * Adres kaçıran biçimler (`ali=40ornek.com`) kapsamda KALIR; sağlayıcı metni
 * bozulmaz.
 */
const QP_ZINCIR = /(?:=[0-9A-Fa-f]{2}){2,}/g;
const QP_TEK = /=([0-9A-Fa-f]{2})/g;
function qpZinciriCoz(zincir) {
    const baytlar = [...zincir.matchAll(/=([0-9A-Fa-f]{2})/g)].map((eslesme) => Number.parseInt(eslesme[1], 16));
    // Geçerli UTF-8 değilse bayt başına bir kod noktası: fail-closed yön korunur.
    return utf8Metin(baytlar) ?? baytlar.map((bayt) => String.fromCharCode(bayt)).join('');
}
function qpTekSekizli(tam, hex) {
    const kod = Number.parseInt(hex, 16);
    // Boşluk (0x20) QP'de gerçek bir kaçıştır ve yapısal sayılır.
    if (kod === 0x20)
        return ' ';
    return yapisalAscii(kod) ?? tam;
}
function birTur(metin) {
    return ikiliGovdeleriCoz(metin
        .replace(QP_YUMUSAK_SATIR, '')
        .replace(YUZDE_KODU, (tam, hex) => kodNoktasi(hex) ?? tam)
        .replace(HTML_ONALTILIK, (tam, hex) => kodNoktasi(hex) ?? tam)
        .replace(HTML_ONDALIK, (tam, ondalik) => {
        const kod = Number.parseInt(ondalik, 10);
        return kod >= 0 && kod <= 0x10ffff ? String.fromCodePoint(kod) : tam;
    })
        // Yapısal olmayan adlı varlık SÖKÜLÜR (bkz. 2e): rol kuralı, liste değil.
        .replace(HTML_AD, (_tam, ad) => HTML_ADLI[ad.toLowerCase()] ?? '')
        .replace(AYRAC_YOKSA_ATLA(metin) ? BULUNMAZ : AYRACLI_AT, '@')
        .replace(SARMALANMIS_AT, '@')
        .replace(COKLU_AT, '@')
        .replace(AYRAC_YOKSA_ATLA(metin) ? BULUNMAZ : AYRACLI_NOKTA, '.')
        .replace(SOZCUK_CIFTI, (_tam, yerel, alan) => `${yerel}@${alan.replace(NOKTA_SOZCUGU, '.')}`)
        .replace(AT_SONRASI_NOKTA, (_tam, bas, kuyruk) => `${bas}${kuyruk.replace(NOKTA_SOZCUGU, '.')}`)
        .replace(RFC2047_BITISIK, '?==?')
        .replace(RFC2047, (tam, kodlama, govde) => rfc2047Coz(tam, kodlama, govde))
        .replace(UTF7_KAYDIRMA, (tam, govde) => {
        const baytlar = b64Bayt(govde);
        const cozum = baytlar ? utf16beMetin(baytlar) : null;
        return cozum !== null && atIsareti(cozum) ? cozum : tam;
    })
        .replace(QP_ZINCIR, (zincir) => qpZinciriCoz(zincir))
        .replace(QP_TEK, (tam, hex) => qpTekSekizli(tam, hex))
        .replace(JS_KACISI, (tam, suslu, dortlu, ikili) => {
        const hex = suslu ?? dortlu ?? ikili;
        return hex === undefined ? tam : (kodNoktasi(hex) ?? tam);
    })
        .replace(CSS_KACISI, (tam, hex) => yapisalAscii(Number.parseInt(hex, 16)) ?? tam));
}
/**
 * Kodlamaları sabit noktaya kadar çözer. `tavan` yalnız testte daraltılır:
 * `tavan = 1` verildiğinde çift kodlanmış adresin SIZDIĞI ölçülür — döngünün
 * kendisi de kalıcı bir öz-testtir.
 */
/**
 * SON ÇÖZÜMLERİN BELLEĞİ — AYNI DİZGE İKİ KEZ ÇÖZÜLMEZ.
 *
 * Fonksiyon SAF: aynı girdi + aynı tavan → aynı çıktı. Bellek bir kısayol
 * değil, aynı hesabın tekrarını önler.
 *
 * NEDEN GEREKLİ (tech-lead, sekizinci dalga · 16.09.2026): görünümler
 * `ATIL_MADDELER`den üretiliyor ve hepsi AYNI metinle başlıyor; atıl madde
 * taşımayan bir metinde 32 görünüm de aynı çözümü 32 kez yapıyordu. Ölçüldü,
 * en kötü girdi `'6'×2000` (üç taban birden eşleşiyor: onaltılık + base64 +
 * base32): 297,1 ms → 12,6 ms. Kapasite küçüktür; amaç tek bir `maskEmails`
 * çağrısı içindeki tekrarı yutmaktır, kalıcı önbellek değil.
 */
const COZUM_BELLEGI = new Map();
const BELLEK_KAPASITESI = 8;
export function kodlamalariCoz(metin, tavan = KOD_COZUM_TAVANI) {
    const anahtar = `${tavan}\u0000${metin}`;
    const bellekten = COZUM_BELLEGI.get(anahtar);
    if (bellekten !== undefined)
        return bellekten;
    let sonuc = metin;
    for (let tur = 0; tur < tavan; tur += 1) {
        const sonraki = birTur(sonuc);
        if (sonraki === sonuc)
            break;
        sonuc = sonraki;
    }
    if (COZUM_BELLEGI.size >= BELLEK_KAPASITESI) {
        const enEski = COZUM_BELLEGI.keys().next().value;
        if (enEski !== undefined)
            COZUM_BELLEGI.delete(enEski);
    }
    COZUM_BELLEGI.set(anahtar, sonuc);
    return sonuc;
}
//# sourceMappingURL=email-mask-decoders.js.map